import { OverlayScrollbarsComponent, OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';
import * as React from 'react';
import { IScrollbarRef, IScrollbarsProps } from './entities';

import 'overlayscrollbars/styles/overlayscrollbars.css';
import { OnScrollbarsScroll, OnScrollbarsUpdate } from './entities/IScrollbarsProps';

import Styles from './assets/scrollbarStyles.scss';

const BCScrollbars = React.memo(
	React.forwardRef((props: IScrollbarsProps, ref: React.ForwardedRef<IScrollbarRef>) => {
		Styles;
		const osRef = React.useRef<OverlayScrollbarsComponentRef>(null);

		const scrollTo = (options: ScrollToOptions) => {
			const osInstance = osRef.current.osInstance();
			if (osInstance) {
				const { scrollOffsetElement } = osInstance.elements();
				scrollOffsetElement.scrollTo(options);
			}
		};

		const scrollToBottom = (behavior?: ScrollBehavior) => {
			const osInstance = osRef.current.osInstance();
			if (osInstance) {
				const { scrollOffsetElement } = osInstance.elements();

				scrollTo({
					behavior,
					top: scrollOffsetElement.scrollHeight
				});
			}
		};

		React.useImperativeHandle(ref, () => ({
			scrollbar: osRef.current,
			scrollTo,
			scrollToBottom
		}));

		React.useEffect(() => {
			if (props.mountScrollPosition && osRef.current) {
				switch (props.mountScrollPosition) {
					case 'bottom': {
						scrollToBottom();
						break;
					}
					default: {
						scrollTo({
							top: props.mountScrollPosition
						});
					}
				}
			}
		}, []);

		return (
			<OverlayScrollbarsComponent
				ref={osRef}
				id={props.id}
				className={['bcScrollableArea', props.cssClass].join(' ')}
				style={props.styles}
				options={{
					scrollbars: { autoHide: 'leave', theme: 'os-theme-light' }
				}}
				events={{
					scroll: props.onScroll,
					updated: props.onUpdate
				}}
			>
				{props.children}
			</OverlayScrollbarsComponent>
		);
	})
);

export default BCScrollbars;

export {
	IScrollbarsProps,
	OnScrollbarsScroll,
	OnScrollbarsUpdate,
	IScrollbarRef as BCScrollbarRef
};
